import React, { createContext, useContext, useState } from "react"

const ErrorContext = createContext<TErrorContext>({
  error: undefined,
  showError: () => {},
  hideError: () => {},
})

export const useErrorPopup = () => useContext(ErrorContext)

interface IError {
  title: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  content: any
}

interface TErrorContext {
  error?: IError
  showError: (error: IError) => void
  hideError: () => void
}

const ErrorPopup = () => {
  const { error, hideError } = useErrorPopup()

  if (!error) {return <></>}

  return <div className="neo__quizResult__errorPopup" onClick={hideError}>
    <div className="neo__quizResult__errorPopupBox">
      <div className="neo__quizResult__errorPopupBox__header">
        {error?.title}
        <div className="neo__quizResult__errorPopupBox__close" />
      </div>
      <div className="neo__quizResult__errorPopupBox__content">
        {error?.content.toString?.()}
      </div>
    </div>
  </div>
}

export const WithErrorPopup: React.FC<React.PropsWithChildren> = ({ children }) => {

  const [error, setError] = useState<IError | undefined>()

  const showError = (error: IError) => {
    setError(error)
  }

  const hideError = () => {
    setError(undefined)
  }

  return <ErrorContext.Provider value={{
    error,
    showError,
    hideError,
  }}>
    {children}
    <ErrorPopup />
  </ErrorContext.Provider>
}
